module.exports = __webpack_public_path__ + "static/img/andy.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/andy.jpg
// module id = OR3y
// module chunks = 0